import * as Styled from './BulletedList.styled';
import type { BulletedListProps } from './BulletedList.typed';
import React from 'react';
import { BulletedListItem } from './BulletedListItem/BulletedListItem';

export const BulletedList = (props: BulletedListProps) => {
  const { children } = props;
  return (
    <Styled.BulletedList>
      {children.map((text, index) => (
        <BulletedListItem key={index}>{text}</BulletedListItem>
      ))}
    </Styled.BulletedList>
  );
};
